import { render, staticRenderFns } from "./collectInfoCard.vue?vue&type=template&id=2df4f7ec&scoped=true"
import script from "./collectInfoCard.vue?vue&type=script&lang=js"
export * from "./collectInfoCard.vue?vue&type=script&lang=js"
import style0 from "./collectInfoCard.vue?vue&type=style&index=0&id=2df4f7ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4f7ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df4f7ec')) {
      api.createRecord('2df4f7ec', component.options)
    } else {
      api.reload('2df4f7ec', component.options)
    }
    module.hot.accept("./collectInfoCard.vue?vue&type=template&id=2df4f7ec&scoped=true", function () {
      api.rerender('2df4f7ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/collectInfoCard.vue"
export default component.exports